import useSelectedParty from '@/features/analysis/hooks/useSelectedParty';
import hasItems from '@/lib/utils/hasItems';

import useCheckupQuery from '../queries/hooks/useCheckup';
import type { CheckupItem, CheckupItemType } from '../types';

const getCheckupItems = (
  items: Maybe<CheckupItem[]>,
  type: CheckupItemType,
) => {
  if (!hasItems(items)) return undefined;

  const itemForType = items.find((item) => item.type === type);

  if (!itemForType) return undefined;
  if (itemForType.status === 'OK') return undefined;

  return hasItems(itemForType.items) ? itemForType.items : undefined;
};

export default function useCheckup() {
  const party = useSelectedParty();

  const { data, isLoading } = useCheckupQuery(party?.id ?? '', {
    enabled: Boolean(party?.id),
  });

  const inventory = getCheckupItems(data, 'INVENTORY');
  const invoices = getCheckupItems(data, 'OVERDUE_INVOICES');
  const policies = getCheckupItems(data, 'POLICIES_TO_PROPOSE');
  const claims = getCheckupItems(data, 'OPEN_CLAIMS');
  const transferCandidates = getCheckupItems(data, 'TRANSFER_CANDIDATES');
  const switchCandidates = getCheckupItems(data, 'SWITCH_CANDIDATES');

  const hasIssues =
    hasItems(claims) || hasItems(invoices) || hasItems(inventory);

  return {
    isLoading,
    hasIssues,
    inventory,
    invoices,
    policies,
    claims,
    transferCandidates,
    switchCandidates,
    lastScanAt: new Date(),
  };
}
